import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/servicio/importer/servicioImporterActions';

export default importerReducers(actions);
